import { gql } from '../../generated'

export const ACCOUNT_EXPERIENCE_ONLINE_BOOKING_COMPANY_CONFIG_FRAGMENT = gql(/* GraphQL */ `
    fragment AccountExperienceOnlineBookingCompanyConfig on OnlineBookingCompanyConfig {
      limitBookingsToServiceAreaEnabled
      brandingColorHex
      afterHoursBannerHtml
      serviceAreaZipCodes {
        zipCode
      }
    }
  `)

export const ACCOUNT_EXPERIENCE_ONLINE_BOOKING_SERVICE_TYPE_CONFIG_FRAGMENT = gql(/* GraphQL */ `
    fragment AccountExperienceOnlineBookingServiceTypeConfig on OnlineBookingServiceTypeConfigs {
      onlineBookingServiceTypeGuid
      companyGuid
      serviceType
      bookingType
      earliestAvailability
      latestAvailability
      legalBlurbHtml
      bookableJobTypes {
        jobType {
          jobTypeGuid
          name
          jobClass
        }
      }
      instantBookingWeeklyScheduleEntries {
        dayOfWeek
        isEnabled
        bookableArrivalWindows {
          arrivalWindow {
            companyAppointmentArrivalWindowGuid
            arrivalWindowStartTime
            arrivalWindowEndTime
          }
        }
      }
    }
  `)

export const ACCOUNT_EXPERIENCE_ONLINE_BOOKING_COMPANY_APPOINTMENT_ARRIVAL_WINDOW_FRAGMENT = gql(/* GraphQL */ `
    fragment CompanyAppointmentArrivalWindow on CompanyAppointmentArrivalWindows {
      companyAppointmentArrivalWindowGuid
      arrivalWindowStartTime
      arrivalWindowEndTime
    }
  `)

export const ACCOUNT_EXPERIENCE_ONLINE_BOOKING_CONFIG_QUERY = gql(/* GraphQL */ `
    query AccountExperienceOnlineBookingConfig($companyGuid: uuid!) {
      companiesByPk(companyGuid: $companyGuid) {
        tzId: timezone
        billingProfile {
          phoneNumber {
            phoneNumber
          }
        }
        onlineBookingCompanyConfig {
          ...AccountExperienceOnlineBookingCompanyConfig
        }
        onlineBookingServiceTypeConfigs {
          ...AccountExperienceOnlineBookingServiceTypeConfig
        }
        companyAppointmentArrivalWindows {
          ...CompanyAppointmentArrivalWindow
        }
      }
    }
  `)

export const ACCOUNT_EXPERIENCE_ONLINE_BOOKING_COMPANY_CONFIG_QUERY = gql(/* GraphQL */ `
    query AccountExperienceOnlineBookingCompanyConfig($companyGuid: uuid!) {
      companiesByPk(companyGuid: $companyGuid) {
        tzId: timezone
        billingProfile {
          phoneNumber {
            phoneNumber
          }
        }
        onlineBookingCompanyConfig {
          ...AccountExperienceOnlineBookingCompanyConfig
        }
        companyAppointmentArrivalWindows {
          ...CompanyAppointmentArrivalWindow
        }
      }
    }
  `)

export const JOB_TYPE_QUERY = gql(/* GraphQL */ `
  query JobTypeQuery($jobTypeGuid: uuid!) {
    jobTypesByPk(jobTypeGuid: $jobTypeGuid) {
      name
      jobClass
    }
  }
`)
